import { STATE } from '../constants';

const googleMapsBranch = STATE.UI.GOOGLE_MAPS;
const apiLoadedPath = googleMapsBranch.API_LOADED;
const librariesPath = googleMapsBranch.LIBRARIES;

const apiLoaded = state => state.getIn(apiLoadedPath);
const libraries = state => state.getIn(librariesPath);

export default {
  apiLoaded,
  libraries
};
